import type { Country } from 'react-phone-number-input';

export const countryPhoneCodes: { [key in string]: Country } = {
  us: 'US',
};
